import { Container, Text, Title, Paper } from "@mantine/core";

const PaymentPartial = () => (
  <Container size="sm" ta="center">
    <Paper mt="xl" p="lg" withBorder>
      <Title mb="md" order={2}>
        Payment partially received
      </Title>
      <Text>
        Ooops, it seems we have received a part of the payment. Sorry for the
        inconvenience.
      </Text>
      <Text mt="md" fw={700}>
        We&apos;ll look into this, but please algo get in touch with
        support@photovortex.com to resolve this!
      </Text>
    </Paper>
  </Container>
);

export default PaymentPartial;
